import {mount, unmount} from "svelte";
import App from "./App.svelte";

const config = Object.freeze({
    "stitch_name": "Dashboard",
    "stitch_site": "stitch_site" // div id
});

////////////////////////////////////////
// NOTE: Don't modify the below, only the config above

let app;

// Listen for the custom event "initstitch" to know when to mount the app
document.addEventListener("initstitch", function (event) {

    if (event.detail === config.stitch_name && !app) {
        const site = document.getElementById(config.stitch_site);

        if (site) {

            app = mount(App, {target: site});
        }
    }

    // Unmount the app when the stitch site (<main>) is removed
    document.addEventListener("removestitch", function (event) {
        if (event.detail === config.stitch_name) {
            unmount(app)
                .then(() => {
                    app = null;
                });
        }
    });
});

const site = document.getElementById(config.stitch_site);
app = site
      ? mount(App, {target: site})
      : null;

export default app;